import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useIsMobile from '../hooks/useIsMobile';
import axios from 'axios';

const API_URL = 'https://enviatupaquete-backend-production.up.railway.app/api';

function LandingPage() {
  const navigate = useNavigate();
  const isMobile = useIsMobile();
  const [menuOpen, setMenuOpen] = useState(false);
  const [cotizando, setCotizando] = useState(false);
  const [resultados, setResultados] = useState([]);
  const [errorCotizacion, setErrorCotizacion] = useState('');
  const [cotizacionData, setCotizacionData] = useState({
    origen_cp: '', destino_cp: '', tipo_paquete: 'caja', peso: '', largo: '', ancho: '', alto: ''
  });

  const handleCotizar = async (e) => {
    e.preventDefault();
    setErrorCotizacion('');
    setResultados([]);
    setCotizando(true);
    try {
      var res = await axios.post(API_URL + '/cotizacion/publico', cotizacionData);
      setResultados(res.data.servicios || []);
      if ((res.data.servicios || []).length === 0) {
        setErrorCotizacion('No se encontraron servicios para esta ruta.');
      }
    } catch (err) {
      setErrorCotizacion('Error al cotizar. Verifica los datos e intenta de nuevo.');
    }
    setCotizando(false);
  };

  const handleSeleccionarServicio = (servicio) => {
    sessionStorage.setItem('cotizacion_publica', JSON.stringify({
      datos: cotizacionData,
      servicio: servicio
    }));
    navigate('/registro');
  };

  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#ffffff' }}>
      
      {/* Header/Navbar */}
      <nav style={{ 
        backgroundColor: 'white', 
        boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
        position: 'fixed', top: 0, left: 0, right: 0, zIndex: 1000
      }}>
        <div style={{ maxWidth: '80rem', margin: '0 auto', padding: isMobile ? '0 0.75rem' : '0 1.5rem' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', height: isMobile ? '3.5rem' : '4rem', alignItems: 'center' }}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <img src="/logo.png" alt="EnvíaTuPaquete" style={{ height: isMobile ? '5rem' : '8rem' }} />
            </div>
            {isMobile ? (
              <div style={{ position: 'relative' }}>
                <button onClick={() => setMenuOpen(!menuOpen)} style={{ background: 'none', border: 'none', fontSize: '1.5rem', cursor: 'pointer', padding: '0.5rem' }}>☰</button>
                {menuOpen && (
                  <div style={{ position: 'absolute', right: 0, top: '100%', backgroundColor: 'white', boxShadow: '0 4px 12px rgba(0,0,0,0.15)', borderRadius: '0.5rem', padding: '0.5rem', minWidth: '200px', zIndex: 1000 }}>
                    <button onClick={() => { navigate('/login'); setMenuOpen(false); }} style={{ width: '100%', padding: '0.75rem 1rem', fontSize: '0.9rem', color: '#ff8c00', backgroundColor: 'transparent', border: 'none', cursor: 'pointer', textAlign: 'left', fontWeight: '600' }}>Iniciar Sesión</button>
                    <button onClick={() => { navigate('/registro'); setMenuOpen(false); }} style={{ width: '100%', padding: '0.75rem 1rem', fontSize: '0.9rem', color: 'white', backgroundColor: '#ff8c00', border: 'none', cursor: 'pointer', textAlign: 'left', fontWeight: '600', borderRadius: '0.375rem', marginTop: '0.25rem' }}>Registrarse Gratis</button>
                  </div>
                )}
              </div>
            ) : (
              <div style={{ display: 'flex', gap: '1rem' }}>
                <button onClick={() => navigate('/login')} style={{ padding: '0.5rem 1.5rem', backgroundColor: 'transparent', color: '#ff8c00', border: '2px solid #ff8c00', borderRadius: '0.375rem', fontWeight: '600', cursor: 'pointer', fontSize: '0.875rem' }}>Iniciar Sesión</button>
                <button onClick={() => navigate('/registro')} style={{ padding: '0.5rem 1.5rem', backgroundColor: '#ff8c00', color: 'white', border: '2px solid #ff8c00', borderRadius: '0.375rem', fontWeight: '600', cursor: 'pointer', fontSize: '0.875rem' }}>Registrarse Gratis</button>
              </div>
            )}
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section style={{
        paddingTop: isMobile ? '5rem' : '8rem',
        paddingBottom: isMobile ? '3rem' : '5rem',
        background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 100%)',
        color: 'white'
      }}>
        <div style={{ maxWidth: '80rem', margin: '0 auto', padding: isMobile ? '0 1rem' : '0 1.5rem' }}>
          <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr', gap: isMobile ? '2rem' : '4rem', alignItems: 'center' }}>
            <div>
              <h1 style={{ 
                fontSize: isMobile ? '1.75rem' : '3rem', 
                fontWeight: 'bold', 
                lineHeight: '1.2',
                marginBottom: '1.5rem'
              }}>
                Envíos sin complicaciones,<br />
                <span style={{ color: '#ff8c00' }}>atención sin robots</span>
              </h1>
              <p style={{ 
                fontSize: isMobile ? '1rem' : '1.25rem', 
                color: '#b0b0b0',
                marginBottom: '2rem',
                lineHeight: '1.6'
              }}>
                Compara precios de las mejores paqueterías, genera tu guía en minutos y recibe atención personalizada de personas reales. Los mejores precios en envíos grandes y tarimas.
              </p>
              <div style={{ display: 'flex', flexDirection: isMobile ? 'column' : 'row', gap: '0.75rem' }}>
                <button onClick={() => document.getElementById('cotizar').scrollIntoView({ behavior: 'smooth' })} style={{
                  padding: isMobile ? '0.875rem 1.5rem' : '1rem 2rem', backgroundColor: '#ff8c00', color: 'white',
                  border: 'none', borderRadius: '0.5rem', fontWeight: '600', cursor: 'pointer', fontSize: isMobile ? '1rem' : '1.125rem'
                }}>Cotizar Ahora →</button>
                <button onClick={() => navigate('/login')} style={{
                  padding: isMobile ? '0.875rem 1.5rem' : '1rem 2rem', backgroundColor: 'transparent', color: 'white',
                  border: '2px solid white', borderRadius: '0.5rem', fontWeight: '600', cursor: 'pointer', fontSize: isMobile ? '1rem' : '1.125rem'
                }}>Ya tengo cuenta</button>
              </div>
            </div>
            <div style={{ textAlign: 'center' }}>
              <div style={{
                backgroundColor: 'rgba(255,140,0,0.1)', borderRadius: '1rem',
                padding: isMobile ? '1.5rem' : '2rem', border: '1px solid rgba(255,140,0,0.3)'
              }}>
                <div style={{ fontSize: isMobile ? '3rem' : '4rem', marginBottom: '1rem' }}>📦</div>
                <div style={{ fontSize: isMobile ? '1.25rem' : '1.5rem', fontWeight: 'bold', color: '#ff8c00' }}>Hasta 70% menos</div>
                <div style={{ color: '#b0b0b0' }}>vs precios de mostrador</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Cotización Pública */}
      <section id="cotizar" style={{ padding: isMobile ? '2rem 0' : '4rem 0', backgroundColor: '#ffffff' }}>
        <div style={{ maxWidth: '60rem', margin: '0 auto', padding: isMobile ? '0 1rem' : '0 1.5rem' }}>
          <h2 style={{ fontSize: isMobile ? '1.5rem' : '2.25rem', fontWeight: 'bold', textAlign: 'center', marginBottom: '0.5rem', color: '#111827' }}>
            Cotiza tu envío ahora
          </h2>
          <p style={{ textAlign: 'center', color: '#6b7280', marginBottom: isMobile ? '1.5rem' : '2rem', fontSize: isMobile ? '0.95rem' : '1.125rem' }}>
            Sin registro, sin compromiso. Compara precios al instante.
          </p>

          <form onSubmit={handleCotizar} style={{
            backgroundColor: '#f9fafb', borderRadius: '1rem', padding: isMobile ? '1.25rem' : '2rem',
            boxShadow: '0 4px 6px rgba(0,0,0,0.07)', border: '1px solid #e5e7eb'
          }}>
            <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr', gap: '1rem' }}>
              <div>
                <label style={{ display: 'block', fontSize: '0.85rem', fontWeight: '600', color: '#374151', marginBottom: '0.3rem' }}>CP Origen</label>
                <input type="text" required maxLength="5" placeholder="Ej: 06600"
                  value={cotizacionData.origen_cp} onChange={(e) => setCotizacionData({...cotizacionData, origen_cp: e.target.value})}
                  style={{ width: '100%', padding: '0.7rem', border: '1.5px solid #e5e7eb', borderRadius: '0.5rem', fontSize: '1rem', boxSizing: 'border-box', backgroundColor: 'white' }}
                />
              </div>
              <div>
                <label style={{ display: 'block', fontSize: '0.85rem', fontWeight: '600', color: '#374151', marginBottom: '0.3rem' }}>CP Destino</label>
                <input type="text" required maxLength="5" placeholder="Ej: 44100"
                  value={cotizacionData.destino_cp} onChange={(e) => setCotizacionData({...cotizacionData, destino_cp: e.target.value})}
                  style={{ width: '100%', padding: '0.7rem', border: '1.5px solid #e5e7eb', borderRadius: '0.5rem', fontSize: '1rem', boxSizing: 'border-box', backgroundColor: 'white' }}
                />
              </div>
              <div>
                <label style={{ display: 'block', fontSize: '0.85rem', fontWeight: '600', color: '#374151', marginBottom: '0.3rem' }}>Tipo de paquete</label>
                <select required value={cotizacionData.tipo_paquete} onChange={(e) => setCotizacionData({...cotizacionData, tipo_paquete: e.target.value})}
                  style={{ width: '100%', padding: '0.7rem', border: '1.5px solid #e5e7eb', borderRadius: '0.5rem', fontSize: '1rem', boxSizing: 'border-box', backgroundColor: 'white' }}>
                  <option value="caja">Caja</option>
                  <option value="sobre">Sobre</option>
                  <option value="pallet">Tarima</option>
                </select>
              </div>
              <div>
                <label style={{ display: 'block', fontSize: '0.85rem', fontWeight: '600', color: '#374151', marginBottom: '0.3rem' }}>Peso (kg)</label>
                <input type="number" required min="0.1" step="0.1" placeholder="Ej: 5"
                  value={cotizacionData.peso} onChange={(e) => setCotizacionData({...cotizacionData, peso: e.target.value})}
                  style={{ width: '100%', padding: '0.7rem', border: '1.5px solid #e5e7eb', borderRadius: '0.5rem', fontSize: '1rem', boxSizing: 'border-box', backgroundColor: 'white' }}
                />
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '0.5rem' }}>
                <div>
                  <label style={{ display: 'block', fontSize: '0.85rem', fontWeight: '600', color: '#374151', marginBottom: '0.3rem' }}>Largo (cm)</label>
                  <input type="number" required min="1" placeholder="cm"
                    value={cotizacionData.largo} onChange={(e) => setCotizacionData({...cotizacionData, largo: e.target.value})}
                    style={{ width: '100%', padding: '0.7rem', border: '1.5px solid #e5e7eb', borderRadius: '0.5rem', fontSize: '1rem', boxSizing: 'border-box', backgroundColor: 'white' }}
                  />
                </div>
                <div>
                  <label style={{ display: 'block', fontSize: '0.85rem', fontWeight: '600', color: '#374151', marginBottom: '0.3rem' }}>Ancho (cm)</label>
                  <input type="number" required min="1" placeholder="cm"
                    value={cotizacionData.ancho} onChange={(e) => setCotizacionData({...cotizacionData, ancho: e.target.value})}
                    style={{ width: '100%', padding: '0.7rem', border: '1.5px solid #e5e7eb', borderRadius: '0.5rem', fontSize: '1rem', boxSizing: 'border-box', backgroundColor: 'white' }}
                  />
                </div>
                <div>
                  <label style={{ display: 'block', fontSize: '0.85rem', fontWeight: '600', color: '#374151', marginBottom: '0.3rem' }}>Alto (cm)</label>
                  <input type="number" required min="1" placeholder="cm"
                    value={cotizacionData.alto} onChange={(e) => setCotizacionData({...cotizacionData, alto: e.target.value})}
                    style={{ width: '100%', padding: '0.7rem', border: '1.5px solid #e5e7eb', borderRadius: '0.5rem', fontSize: '1rem', boxSizing: 'border-box', backgroundColor: 'white' }}
                  />
                </div>
              </div>
            </div>

            <button type="submit" disabled={cotizando} style={{
              width: '100%', marginTop: '1.25rem', padding: '0.875rem',
              background: cotizando ? '#ccc' : 'linear-gradient(135deg, #ff8c00, #ff6b00)',
              color: 'white', border: 'none', borderRadius: '0.5rem',
              fontWeight: '700', fontSize: '1.05rem', cursor: cotizando ? 'not-allowed' : 'pointer',
              boxShadow: cotizando ? 'none' : '0 4px 14px rgba(255,140,0,0.4)'
            }}>
              {cotizando ? 'Cotizando...' : 'Cotizar Envío Gratis'}
            </button>
          </form>

          {errorCotizacion && (
            <div style={{ textAlign: 'center', color: '#dc2626', marginTop: '1rem', fontSize: '0.95rem' }}>
              {errorCotizacion}
            </div>
          )}

          {resultados.length > 0 && (
            <div style={{ marginTop: '1.5rem' }}>
              <h3 style={{ fontSize: isMobile ? '1.1rem' : '1.35rem', fontWeight: '600', marginBottom: '1rem', textAlign: 'center', color: '#111827' }}>
                {resultados.length} opciones encontradas
              </h3>
              <div style={{ display: 'grid', gap: '0.75rem' }}>
                {resultados.map(function(s, i) {
                  return (
                    <div key={i} style={{
                      backgroundColor: 'white', borderRadius: '0.75rem', padding: isMobile ? '1rem' : '1.25rem',
                      boxShadow: '0 2px 8px rgba(0,0,0,0.08)', border: '1px solid #e5e7eb',
                      display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr auto', gap: '1rem', alignItems: 'center'
                    }}>
                      <div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', flexWrap: 'wrap' }}>
                          <span style={{ fontWeight: '700', fontSize: '1rem', color: '#111827' }}>{s.paqueteria}</span>
                          <span style={{ fontSize: '0.8rem', color: '#6b7280', backgroundColor: '#f3f4f6', padding: '0.15rem 0.5rem', borderRadius: '9999px' }}>{s.servicio}</span>
                        </div>
                        <div style={{ fontSize: '0.85rem', color: '#6b7280', marginTop: '0.25rem' }}>{s.tiempo_entrega}</div>
                      </div>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', justifyContent: isMobile ? 'space-between' : 'flex-end' }}>
                        <span style={{ fontSize: '1.35rem', fontWeight: '800', color: '#ff8c00' }}>
                          ${s.costo.toFixed(2)}
                        </span>
                        <button onClick={function() { handleSeleccionarServicio(s); }} style={{
                          padding: '0.5rem 1.25rem', backgroundColor: '#ff8c00', color: 'white',
                          border: 'none', borderRadius: '0.375rem', fontWeight: '600', cursor: 'pointer', fontSize: '0.85rem', whiteSpace: 'nowrap'
                        }}>
                          Enviar ahora
                        </button>
                      </div>
                    </div>
                  );
                })}
              </div>
              <p style={{ textAlign: 'center', marginTop: '1rem', fontSize: '0.85rem', color: '#6b7280' }}>
                Precios incluyen IVA. Regístrate gratis para generar tu guía.
              </p>
            </div>
          )}
        </div>
      </section>

      {/* Paqueterías */}
      <section style={{ padding: isMobile ? '2rem 0' : '3rem 0', backgroundColor: '#f9fafb' }}>
        <div style={{ maxWidth: '80rem', margin: '0 auto', padding: isMobile ? '0 1rem' : '0 1.5rem' }}>
          <p style={{ textAlign: 'center', color: '#6b7280', marginBottom: '1.5rem', fontSize: isMobile ? '0.875rem' : '1rem' }}>
            Trabajamos con las mejores paqueterías de México
          </p>
          <div style={{ 
            display: 'flex', justifyContent: 'center', alignItems: 'center',
            gap: isMobile ? '0.5rem' : '3rem', flexWrap: 'wrap'
          }}>
            {['PAQUETEXPRESS', 'DHL', 'ESTAFETA', 'TRES GUERRAS', 'FLETES MÉXICO'].map((paq) => (
              <div key={paq} style={{
                padding: isMobile ? '0.5rem 0.75rem' : '1rem 2rem',
                backgroundColor: 'white', borderRadius: '0.5rem',
                boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                fontWeight: '600', color: '#374151', fontSize: isMobile ? '0.7rem' : '1rem'
              }}>{paq}</div>
            ))}
          </div>
        </div>
      </section>

      {/* Diferenciadores */}
      <section style={{ padding: isMobile ? '3rem 0' : '5rem 0' }}>
        <div style={{ maxWidth: '80rem', margin: '0 auto', padding: isMobile ? '0 1rem' : '0 1.5rem' }}>
          <h2 style={{ fontSize: isMobile ? '1.5rem' : '2.25rem', fontWeight: 'bold', textAlign: 'center', marginBottom: '0.75rem', color: '#111827' }}>
            ¿Por qué elegirnos?
          </h2>
          <p style={{ textAlign: 'center', color: '#6b7280', marginBottom: isMobile ? '2rem' : '3rem', fontSize: isMobile ? '0.95rem' : '1.125rem' }}>
            No somos otra plataforma más. Somos tu aliado en envíos.
          </p>
          
          <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : 'repeat(3, 1fr)', gap: isMobile ? '1rem' : '2rem' }}>
            {[
              { icon: '👨‍💼', title: 'Atención Personalizada', desc: 'Habla con personas reales, no con bots. Te ayudamos por WhatsApp, teléfono o email cuando lo necesites.' },
              { icon: '💰', title: 'Mejores Precios en Paquetes Grandes', desc: 'Especialistas en envíos de gran tamaño y tarimas. Precios que no encontrarás en otras plataformas.' },
              { icon: '⚡', title: 'Guías en Minutos', desc: 'Cotiza, compara y genera tu guía en menos de 5 minutos. Sin filas, sin esperas, sin complicaciones.' }
            ].map((card, i) => (
              <div key={i} style={{
                backgroundColor: 'white', borderRadius: '1rem',
                padding: isMobile ? '1.5rem' : '2rem',
                boxShadow: '0 4px 6px rgba(0,0,0,0.1)', border: '1px solid #e5e7eb', textAlign: 'center'
              }}>
                <div style={{ 
                  fontSize: isMobile ? '2rem' : '3rem', 
                  backgroundColor: '#fff7ed',
                  width: isMobile ? '3.5rem' : '5rem', height: isMobile ? '3.5rem' : '5rem',
                  borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center',
                  margin: '0 auto 1rem'
                }}>{card.icon}</div>
                <h3 style={{ fontSize: isMobile ? '1rem' : '1.25rem', fontWeight: '600', marginBottom: '0.75rem', color: '#111827' }}>{card.title}</h3>
                <p style={{ color: '#6b7280', lineHeight: '1.6', fontSize: isMobile ? '0.9rem' : '1rem' }}>{card.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Cómo Funciona */}
      <section style={{ padding: isMobile ? '3rem 0' : '5rem 0', backgroundColor: '#1a1a2e', color: 'white' }}>
        <div style={{ maxWidth: '80rem', margin: '0 auto', padding: isMobile ? '0 1rem' : '0 1.5rem' }}>
          <h2 style={{ fontSize: isMobile ? '1.5rem' : '2.25rem', fontWeight: 'bold', textAlign: 'center', marginBottom: isMobile ? '2rem' : '3rem' }}>
            ¿Cómo funciona?
          </h2>
          
          <div style={{ display: 'grid', gridTemplateColumns: isMobile ? 'repeat(2, 1fr)' : 'repeat(4, 1fr)', gap: isMobile ? '1.5rem' : '2rem' }}>
            {[
              { num: '1', icon: '📝', title: 'Regístrate', desc: 'Crea tu cuenta gratis en menos de 2 minutos' },
              { num: '2', icon: '💳', title: 'Recarga Saldo', desc: 'Agrega saldo a tu cuenta de forma segura' },
              { num: '3', icon: '📦', title: 'Cotiza y Envía', desc: 'Compara precios y genera tu guía al instante' },
              { num: '4', icon: '🚚', title: 'Rastrea', desc: 'Sigue tu paquete hasta su destino' }
            ].map((paso) => (
              <div key={paso.num} style={{ textAlign: 'center' }}>
                <div style={{
                  width: isMobile ? '2.5rem' : '4rem', height: isMobile ? '2.5rem' : '4rem',
                  backgroundColor: '#ff8c00', borderRadius: '50%',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  fontSize: isMobile ? '1rem' : '1.5rem', fontWeight: 'bold', margin: '0 auto 0.75rem'
                }}>{paso.num}</div>
                <div style={{ fontSize: isMobile ? '1.5rem' : '2rem', marginBottom: '0.5rem' }}>{paso.icon}</div>
                <h3 style={{ fontSize: isMobile ? '0.9rem' : '1.125rem', fontWeight: '600', marginBottom: '0.5rem' }}>{paso.title}</h3>
                <p style={{ color: '#b0b0b0', fontSize: isMobile ? '0.75rem' : '0.875rem' }}>{paso.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Especialidad en Tarimas */}
      <section style={{ padding: isMobile ? '3rem 0' : '5rem 0', backgroundColor: '#fff7ed' }}>
        <div style={{ maxWidth: '80rem', margin: '0 auto', padding: isMobile ? '0 1rem' : '0 1.5rem' }}>
          <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr', gap: isMobile ? '2rem' : '4rem', alignItems: 'center' }}>
            <div>
              <h2 style={{ fontSize: isMobile ? '1.5rem' : '2.25rem', fontWeight: 'bold', marginBottom: '1rem', color: '#111827' }}>
                Especialistas en envíos de <span style={{ color: '#ff8c00' }}>Tarimas y Carga Grande</span>
              </h2>
              <p style={{ fontSize: isMobile ? '1rem' : '1.125rem', color: '#6b7280', marginBottom: '1.5rem', lineHeight: '1.6' }}>
                ¿Necesitas enviar mercancía en tarimas o paquetes de gran tamaño? Tenemos las mejores tarifas con Paquetexpress, Tres Guerras y Fletes México.
              </p>
              <ul style={{ listStyle: 'none', padding: 0 }}>
                {['Tarimas hasta 2,000 kg', 'Recolección incluida', 'Cobertura nacional', 'Precios preferenciales'].map((item, i) => (
                  <li key={i} style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', marginBottom: '0.75rem', fontSize: isMobile ? '1rem' : '1.125rem', color: '#374151' }}>
                    <span style={{ color: '#ff8c00', fontWeight: 'bold' }}>✓</span> {item}
                  </li>
                ))}
              </ul>
              <button onClick={() => navigate('/registro')} style={{
                marginTop: '1.5rem', padding: isMobile ? '0.875rem 1.5rem' : '1rem 2rem',
                backgroundColor: '#ff8c00', color: 'white', border: 'none',
                borderRadius: '0.5rem', fontWeight: '600', cursor: 'pointer', fontSize: '1rem'
              }}>Cotizar Envío de Tarima →</button>
            </div>
            <div style={{ backgroundColor: 'white', borderRadius: '1rem', padding: isMobile ? '2rem' : '3rem', boxShadow: '0 4px 6px rgba(0,0,0,0.1)', textAlign: 'center' }}>
              <div style={{ fontSize: isMobile ? '4rem' : '6rem', marginBottom: '1rem' }}>🏗️</div>
              <div style={{ fontSize: isMobile ? '1.25rem' : '1.5rem', fontWeight: 'bold', color: '#111827' }}>Tarimas y Fletes</div>
              <div style={{ color: '#6b7280' }}>Hasta 2,000 kg por envío</div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Final */}
      <section style={{ padding: isMobile ? '3rem 0' : '5rem 0', backgroundColor: '#ff8c00', color: 'white', textAlign: 'center' }}>
        <div style={{ maxWidth: '80rem', margin: '0 auto', padding: isMobile ? '0 1rem' : '0 1.5rem' }}>
          <h2 style={{ fontSize: isMobile ? '1.5rem' : '2.25rem', fontWeight: 'bold', marginBottom: '1rem' }}>¿Listo para enviar?</h2>
          <p style={{ fontSize: isMobile ? '1rem' : '1.25rem', marginBottom: '2rem', opacity: 0.9 }}>Crea tu cuenta gratis y genera tu primera guía hoy mismo</p>
          <button onClick={() => navigate('/registro')} style={{
            padding: isMobile ? '0.875rem 2rem' : '1rem 3rem', backgroundColor: 'white', color: '#ff8c00',
            border: 'none', borderRadius: '0.5rem', fontWeight: 'bold', cursor: 'pointer', fontSize: isMobile ? '1rem' : '1.125rem'
          }}>Crear Cuenta Gratis</button>
        </div>
      </section>

      {/* Footer */}
      <footer style={{ backgroundColor: '#111827', color: 'white', padding: isMobile ? '2rem 0' : '3rem 0' }}>
        <div style={{ maxWidth: '80rem', margin: '0 auto', padding: isMobile ? '0 1rem' : '0 1.5rem' }}>
          <div style={{ display: 'grid', gridTemplateColumns: isMobile ? 'repeat(2, 1fr)' : 'repeat(4, 1fr)', gap: isMobile ? '1.5rem' : '2rem' }}>
            <div style={{ gridColumn: isMobile ? '1 / -1' : 'auto' }}>
              <h4 style={{ fontWeight: '600', marginBottom: '0.75rem', fontSize: isMobile ? '0.9rem' : '1rem' }}>EnvíaTuPaquete.mx</h4>
              <p style={{ color: '#9ca3af', fontSize: '0.875rem', lineHeight: '1.6' }}>Tu aliado en envíos con atención personalizada y los mejores precios.</p>
            </div>
            <div>
              <h4 style={{ fontWeight: '600', marginBottom: '0.75rem', fontSize: isMobile ? '0.9rem' : '1rem' }}>Enlaces</h4>
              <ul style={{ listStyle: 'none', padding: 0 }}>
                <li style={{ marginBottom: '0.5rem' }}><span onClick={() => navigate('/login')} style={{ color: '#9ca3af', cursor: 'pointer', fontSize: '0.875rem' }}>Iniciar Sesión</span></li>
                <li style={{ marginBottom: '0.5rem' }}><span onClick={() => navigate('/registro')} style={{ color: '#9ca3af', cursor: 'pointer', fontSize: '0.875rem' }}>Registrarse</span></li>
              </ul>
            </div>
            <div>
              <h4 style={{ fontWeight: '600', marginBottom: '0.75rem', fontSize: isMobile ? '0.9rem' : '1rem' }}>Paqueterías</h4>
              <ul style={{ listStyle: 'none', padding: 0, color: '#9ca3af', fontSize: '0.875rem' }}>
                {['Paquetexpress', 'DHL', 'Estafeta', 'Tres Guerras', 'Fletes México'].map(p => (
                  <li key={p} style={{ marginBottom: '0.375rem' }}>{p}</li>
                ))}
              </ul>
            </div>
            <div>
              <h4 style={{ fontWeight: '600', marginBottom: '0.75rem', fontSize: isMobile ? '0.9rem' : '1rem' }}>Contacto</h4>
              <ul style={{ listStyle: 'none', padding: 0, color: '#9ca3af', fontSize: '0.875rem' }}>
                <li style={{ marginBottom: '0.5rem' }}>📧 contacto@enviatupaquete.mx</li>
                <li style={{ marginBottom: '0.5rem' }}>📱 WhatsApp: (614) 123-4567</li>
              </ul>
            </div>
          </div>
          <div style={{ borderTop: '1px solid #374151', marginTop: '2rem', paddingTop: '1.5rem', textAlign: 'center', color: '#9ca3af', fontSize: isMobile ? '0.75rem' : '0.875rem' }}>
            © 2025 EnvíaTuPaquete.mx - Todos los derechos reservados
          </div>
        </div>
      </footer>
    </div>
  );
}

export default LandingPage;
